import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // 标题文本
  title: {
    type: String,
    default: ''
  },
  // 右侧文本
  rightText: {
    type: String,
    default: ''
  },
  // 背景颜色
  backgroundColor: {
    type: String,
    default: '#fff'
  },
  // 标题颜色
  titleColor: {
    type: String,
    default: '#111'
  },
  // 右侧文本颜色
  rightTextColor: {
    type: String,
    default: '#333'
  },
  // 图标颜色
  iconColor: {
    type: String,
    default: '#333'
  },
  // 是否固定在顶部
  fixed: {
    type: Boolean,
    default: true
  },
  // 是否显示底部边框
  showBorder: {
    type: Boolean,
    default: true
  },
  // 是否显示返回按钮
  showBack: {
    type: Boolean,
    default: true
  },
  // 自定义返回逻辑
  customBack: {
    type: Function,
    default: null
  },
  // z-index层级
  zIndex: {
    type: Number,
    default: 100
  }
},
  emits: ['rightClick'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "17d945be": (props.zIndex)
}))

const props = __props;

const emit = __emit;

// 返回按钮处理
const handleBack = () => {
  if (props.customBack) {
    props.customBack();
  } else {
    history.back();
  }
};

// 右侧点击处理
const handleRightClick = () => {
  emit('rightClick');
};

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["custom-title-bar", { 'is-fixed': __props.fixed }]),
    style: _normalizeStyle({
    backgroundColor: __props.backgroundColor,
    color: __props.titleColor,
    borderBottom: __props.showBorder ? '1px solid #eee' : 'none'
  })
  }, [
    (__props.showBack)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "left-area",
          onClick: handleBack
        }, [
          _renderSlot(_ctx.$slots, "left", {}, () => [
            _createVNode(_component_SvgIcon, {
              name: "back",
              class: "back-icon",
              color: __props.iconColor,
              size: "18"
            }, null, 8, ["color"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "title",
      style: _normalizeStyle({ color: __props.titleColor })
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ])
    ], 4),
    _createElementVNode("div", {
      class: "right-area",
      style: _normalizeStyle({ color: __props.rightTextColor }),
      onClick: handleRightClick
    }, [
      _renderSlot(_ctx.$slots, "right", {}, () => [
        _createTextVNode(_toDisplayString(__props.rightText), 1)
      ])
    ], 4)
  ], 6))
}
}

})